module.exports = __webpack_public_path__ + "img/S-头.9003c19d.png";